import type { ChakraTheme} from '@chakra-ui/react'
import { extendTheme } from '@chakra-ui/react'

import { components } from './components'
import { foundations } from './foundations'
import { layerStyles } from './layers'
import { semanticTokens } from './semantic-tokens'
import { styles } from './styles'

export const config = {
  cssVarPrefix: 'ce',
}

export const theme = extendTheme({
  semanticTokens,
  styles,
  ...foundations,
  layerStyles,
  components,
  config,
}) as ChakraTheme
